import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@/app/store/hooks';
import { ROUTES } from '@/shared/config/routes';

/** Gate for `/platform/*` — super admin only, independent of any store membership. */
export function RequireSuperAdmin() {
  const user = useAppSelector((state) => state.auth.user);

  if (!user?.isSuperAdmin) {
    return <Navigate to={ROUTES.noAccess} replace />;
  }

  return <Outlet />;
}
